import { render, staticRenderFns } from "./DurationInput.vue?vue&type=template&id=38a0ee30&scoped=true&"
import script from "./DurationInput.vue?vue&type=script&lang=ts&"
export * from "./DurationInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a0ee30",
  null
  
)

export default component.exports